export default {"src":"/_next/static/media/trek.037ef0d9.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};